import React, { Suspense, lazy } from "react";
import Loader from "../../components/Loader";
import CentralEventRegistration2026 from "../../components/CentralEvent/BiAnnualEvent2026/CentralEventRegistration2026";
import GeneralEventRegistrationScreen from "./GeneralEventRegistrationScreen";

// The 2022 and 2024 conventions still have to open - the registrations are
// part of the record - but nobody registers on them any more. They are fetched
// only if one of those two ids is asked for. The live convention and the
// general form stay in the first download, so a registrant never waits.
//
// The two components themselves are untouched; only how they are reached is.
const CentralEventRegistration2022 = lazy(() =>
  import(
    "../../components/CentralEvent/BiAnnualEvent2022/CentralEventRegistration2022"
  )
);
const CentralEventRegistration2024 = lazy(() =>
  import(
    "../../components/CentralEvent/BiAnnualEvent2024/CentralEventRegistration2024"
  )
);

const EventRegisterScreen = ({ match, history }) => {
  const { id } = match.params;

  let Registration = GeneralEventRegistrationScreen;
  if (id === "42141") {
    Registration = CentralEventRegistration2022;
  } else if (id === "42042") {
    Registration = CentralEventRegistration2024;
  } else if (id === "12024") {
    Registration = CentralEventRegistration2026;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Registration history={history} match={match} />
    </Suspense>
  );
};

export default EventRegisterScreen;
